import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

let _scopedClient: SupabaseClient | null = null;
let _currentLocationId: string | null = null;

export function setLocationHeader(locationId: string) {
  _currentLocationId = locationId;
  _scopedClient = createClient(supabaseUrl, supabaseAnonKey, {
    global: {
      headers: {
        'x-location-id': locationId,
      },
    },
  });
}

export function getScopedClient(): SupabaseClient {
  if (!_scopedClient) {
    throw new Error('Location header not set. Call setLocationHeader() first.');
  }
  return _scopedClient;
}

export function getLocationId(): string | null {
  return _currentLocationId;
}
